import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminRoute = ({ children, user: userProp, isAdmin: isAdminProp }) => {
  // ✅ Always call hook (never conditionally)
  const reduxUser = useSelector((state) => state.auth.currentUser);
  const user = userProp || reduxUser;

  const isAdmin =
    isAdminProp || user?.email?.toLowerCase() === "kashyapsonu116@gmail.com";

  if (!user) {
    console.log("🔄 Waiting for user...");
    return <div>Loading...</div>;
  }

  if (!isAdmin) {
    console.warn("❌ Not authorized. Redirecting to /");
    return <Navigate to="/" replace />;
  }

  console.log("✅ Admin authorized. Rendering page...");
  return children;
};

export default AdminRoute;
